import { createRouter, createWebHistory } from 'vue-router'
import { getCalculatorBySlug } from '@/calculators/registry'
import HomeView from '@/pages/HomeView.vue'
import DirectoryView from '@/pages/DirectoryView.vue'
import CalculatorPageView from '@/pages/CalculatorPageView.vue'
import AboutView from '@/pages/AboutView.vue'
import MethodologyView from '@/pages/MethodologyView.vue'
import PrivacyView from '@/pages/PrivacyView.vue'
import TermsView from '@/pages/TermsView.vue'
import DisclaimerView from '@/pages/DisclaimerView.vue'
import NotFoundView from '@/pages/NotFoundView.vue'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    { path: '/', name: 'home', component: HomeView },
    { path: '/calculators', name: 'calculators', component: DirectoryView },
    {
      path: '/:slug',
      name: 'calculator',
      component: CalculatorPageView,
      props: true,
      beforeEnter: (to) => {
        const slug = to.params.slug as string
        const calc = getCalculatorBySlug(slug)
        if (!calc) {
          return { name: 'not-found', params: { pathMatch: to.path.slice(1) } }
        }
      },
    },
    { path: '/about', name: 'about', component: AboutView },
    { path: '/methodology', name: 'methodology', component: MethodologyView },
    { path: '/privacy', name: 'privacy', component: PrivacyView },
    { path: '/terms', name: 'terms', component: TermsView },
    { path: '/disclaimer', name: 'disclaimer', component: DisclaimerView },
    { path: '/:pathMatch(.*)*', name: 'not-found', component: NotFoundView },
  ],
  scrollBehavior() {
    return { top: 0 }
  },
})

export default router
